import React from 'react'

const AsteriskStyle = () => {
  return (
    <>
        <span className="text-red-500 font-semibold ">*</span>
    </>
  )
}

export default AsteriskStyle